var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
const ProfileIconContainer = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $width }) => $width && `width: ${$width};`}
  ${({ $height }) => $height && `height: ${$height};`}
`;
const ActiveStatusCricle = styled.div `
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  ${({ $active }) => $active ? 'background-color: #00FF66;' : 'background-color: #777583;'}
  border: 1px solid #1A1A1D;
`;
const UserProfileIcon = ({ accountId, showStatus = true, width = '24px', height = '24px', active = false, getIconFromCache, }) => {
    const [imageUrl, setImageUrl] = useState('https://i.imgur.com/e8buxpa.png');
    useEffect(() => {
        const setImage = () => __awaiter(void 0, void 0, void 0, function* () {
            const image = yield getIconFromCache(accountId);
            if (image) {
                setImageUrl(image);
            }
        });
        setImage();
    }, []);
    return (_jsxs(ProfileIconContainer, Object.assign({ "$width": width, "$height": height }, { children: [_jsx("img", { src: imageUrl, alt: `profile-icon-${accountId}`, className: "rounded-circle", style: { width: width, height: height, objectFit: 'cover' } }), showStatus && _jsx(ActiveStatusCricle, { "$active": active })] })));
};
export default UserProfileIcon;
